import { render, staticRenderFns } from "./20211202.vue?vue&type=template&id=c34228c2"
import script from "./20211202.vue?vue&type=script&lang=js"
export * from "./20211202.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports